import { handleActions } from 'redux-actions'
import {
  setLoadingChatImagesExport,
  setLoadingChatImagesExportDone,
  setLoadingExport,
  setLoadingExportDone,
  setLoadingJoinGoal,
  setLoadingJoinGoalDone,
} from './loadingActions'

class State {
  joinGoal = false
  export = false
  chatImagesExport = false
}

export const loading = handleActions<State, any>(
  {
    [String(setLoadingJoinGoal)]: (state: State): State => ({
      ...state,
      joinGoal: true,
    }),
    [String(setLoadingJoinGoalDone)]: (state: State): State => ({
      ...state,
      joinGoal: false,
    }),
    [String(setLoadingExport)]: (state: State): State => ({
      ...state,
      export: true,
    }),
    [String(setLoadingExportDone)]: (state: State): State => ({
      ...state,
      export: false,
    }),
    [String(setLoadingChatImagesExport)]: (state: State): State => ({
      ...state,
      chatImagesExport: true,
    }),
    [String(setLoadingChatImagesExportDone)]: (state: State): State => ({
      ...state,
      chatImagesExport: false,
    }),
  },
  new State(),
)

export { State as LoadingState }
